var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowSkullHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10v3.764a2 2 0 01-1.106 1.789L16 17v1a3 3 0 01-2.824 2.995L12.95 21c.022-.107.037-.218.044-.33L13 20.5V20a2 2 0 00-1.85-1.994L11 18H9a2 2 0 00-1.995 1.85L7 20v.5c0 .171.017.339.05.5H7a3 3 0 01-3-3v-1l-2.894-1.447A2 2 0 010 13.763V10C0 4.477 4.477 0 10 0zM6 9a2 2 0 100 4 2 2 0 000-4zm8 0a2 2 0 100 4 2 2 0 000-4z"
  })));
}
export default __webpack_public_path__ + "static/svg/wow-skull-head.svg";
export { SvgWowSkullHead as ReactComponent };